import { render } from "./merge-link-button.vue?vue&type=template&id=7d027a6f&lang=pug"
import script from "./merge-link-button.vue?vue&type=script&lang=js"
export * from "./merge-link-button.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__